module.exports = __webpack_public_path__ + "static/media/mockup1.df32c82d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/mockup1.png
// module id = 893
// module chunks = 0